import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { IntlProvider } from "react-intl";
import en from "./en.json";
import { useSelector } from "react-redux";

const LocalizationContext = createContext();

export const useLocalization = () => useContext(LocalizationContext);

export const LocalizationProvider = ({ children }) => {
  const [locale, setLocale] = useState();
  const [messages, setMessages] = useState({});
  const { scope, languages, languageStatus } = useSelector(
    (state) => state.controller
  );
  const { controller } = useSelector((state) => state.controllers);
  const isLanguageCalled = useMemo(
    () => ["succeeded", "failed"]?.includes(languageStatus),
    [languageStatus]
  );
  const fetchLocalization = async (controller, scope, lang) => {
    if (!lang) return;
    try {
      const response = await fetch(
        `${import.meta.env.VITE_DOMAIN}/${controller}/${lang}/${lang}.json`
      );
      const data = await response.json();
      setMessages(data);
      if (lang) document.documentElement.lang = lang;
    } catch (error) {
      setMessages(en);
      document.documentElement.lang = "en";
    }
  };

  useEffect(() => {
    const lang = navigator.language || navigator.userLanguage; // Get browser language
    const shortLang = lang.split("-")[0];
    setLocale(shortLang || "en");
  }, []);

  useEffect(() => {
    if (locale && languages?.length) {
      const hasLanguage = languages
        ?.map(({ value }) => value)
        ?.includes(locale);
      if (hasLanguage) fetchLocalization(controller, scope, locale);
      else {
        const hasEnLanguage = languages
          ?.map(({ value }) => value)
          ?.includes("en");
        if (hasEnLanguage) fetchLocalization(controller, scope, "en");
        else fetchLocalization("global", scope, locale);
      }
    } else if (isLanguageCalled) {
      fetchLocalization(controller, scope, locale);
    }
  }, [locale, languages]);

  return (
    <LocalizationContext.Provider value={{ locale, messages }}>
      <IntlProvider locale={locale} messages={messages}>
        {children}
      </IntlProvider>
    </LocalizationContext.Provider>
  );
};
